import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LabResultsConfigItem } from '../useLabResultsConfig';

type Selection = LabResultsConfigItem | null;

type SelectionContextType = {
  selection: Selection;
  setSelection: (selection: Selection) => void;
};

const SelectionContext = createContext<SelectionContextType | undefined>(
  undefined,
);

type SelectionProviderProps = {
  children: ReactNode;
};

function SelectionProvider({ children }: SelectionProviderProps) {
  const [selection, setSelection] = useState<Selection>(null);

  return (
    <SelectionContext.Provider value={{ selection, setSelection }}>
      {children}
    </SelectionContext.Provider>
  );
}

function useSelectionContext() {
  const context = useContext(SelectionContext);

  if (!context) {
    throw new Error(
      'useSelectionContext must be used within a SelectionProvider',
    );
  }

  return context;
}

const Selection = {
  Provider: SelectionProvider,
};

export { Selection, useSelectionContext };
